<dx-form
  id="formTasima"
  [(formData)]="tasimaForm"
  [colCount]="1"
  [showColonAfterLabel]="true"
  [labelMode]="labelMode"
  [labelLocation]="labelLocation">

  <dxi-item dataField="piOkuncacakYil" [label]="{text: 'Okunacak Yıl'}" [validationRules]="required">
    <dk-ct-gen-lookup
      [validationRules]="required"
      [selectedValue]="tasimaForm.piOkunacakYil"
      (valueChange)="tasimaForm.piOkunacakYil = $event.value"
      [lookUpType]="'TEM_DONEM'"
      [valueExpr]="'ozelKod'"
      [labelMode]="labelMode"
      [label]="'Okunacak Yıl'"
      [sortConfig]="{ field: 'ozelKod', direction: 'DESC' }"
    ></dk-ct-gen-lookup>
  </dxi-item>
  <dxi-item dataField="piYazilacakYil" [label]="{text: 'Yazılacak Yıl'}" [validationRules]="required">
    <dk-ct-gen-lookup
      [validationRules]="required"
      [selectedValue]="tasimaForm.piYazilacakYil"
      (valueChange)="tasimaForm.piYazilacakYil = $event.value"
      [lookUpType]="'TEM_DONEM'"
      [valueExpr]="'ozelKod'"
      [labelMode]="labelMode"
      [label]="'Yazılacak Yıl'"
      [sortConfig]="{ field: 'ozelKod', direction: 'DESC' }"
    ></dk-ct-gen-lookup>
  </dxi-item>

</dx-form>
<dx-toolbar class="bottomSaveCancelBtn">
  <dxi-item location="after">
    <dx-button stylingMode="contained" type="danger" text="İptal"
               (onClick)="handleCancelClick()"></dx-button>
  </dxi-item>
  <dxi-item location="after">
    <dx-button stylingMode="contained" type="default" text="Kaydet"
               [disabled]="isLoading"
               (onClick)="handleSaveClick()"></dx-button>
  </dxi-item>


</dx-toolbar>
<dx-load-panel
  container="#formTasima"
  shadingColor="rgba(0,0,0,0.4)"
  [width]="300"
  [visible]="isLoading"
  [showPane]="true"
  [shading]="true"
  [position]="{ of: '#formTasima' }"
></dx-load-panel>


